import { n as e, t } from "./createApiQueryClient-DwmsEdyU.js";
import { t as n } from "./v20240509-JTkMfURM.js";
import { t as r } from "./v20240730-d4WzapES.js";
import { t as i } from "./v99990101-BAHO7XXd.js";
import { canadianProvinces as a, countriesAlpha2 as o, countriesAlpha2Emojis as s, getStateOptions as c, isRegionState as l, statesForCountry as u, statesWithNamesForCountry as d, toCountryLabel as f, toStateLabel as p, usStates as m } from "./utils/commonEnums/index.js";
import { CUSTOMER_ADDRESS_PURPOSES as h, getBillingAddress as g, getShippingAddress as _, isShippingSameAsBilling as v, toBillingOnlyAddresses as y, toCustomerAddresses as b } from "./utils/commonModels/index.js";
import { _ as x, a as S, b as C, c as w, d as T, f as E, g as D, h as O, i as k, l as A, m as j, n as M, o as N, p as P, r as F, s as I, t as L, u as R, v as z, y as B } from "./utils-C8-2hwbF.js";
import { QueryClientProvider as V } from "@tanstack/react-query";
import { PersistQueryClientProvider as H } from "@tanstack/react-query-persist-client";
import { jsx as U } from "react/jsx-runtime";
import { ReactQueryDevtools as W, ReactQueryDevtoolsPanel as G } from "@tanstack/react-query-devtools/production";
//#region src/apiQueryProvider.tsx
var K = typeof process < "u" ? "1539d13d9036a80a9d35b4607d23bbb560539c73" : void 0, q = ({ client: t, persister: n, maxAge: r = e, children: i }) => n ? /* @__PURE__ */ U(H, {
	client: t,
	persistOptions: {
		persister: n,
		maxAge: r,
		buster: K,
		dehydrateOptions: {
			shouldDehydrateMutation: () => !1,
			shouldDehydrateQuery: (e) => e.queryKey.includes("persist") && !e.queryKey.includes("legacy") && e.state.status === "success"
		}
	},
	children: i
}) : /* @__PURE__ */ U(V, {
	client: t,
	children: i
}), J = W, Y = G, X = {
	dashboard20240730Client: r,
	dashboardv20240509Client: n,
	dashboardv99990101Client: i
};
//#endregion
export { J as ApiQueryDevtools, Y as ApiQueryDevtoolsPanel, q as ApiQueryProvider, h as CUSTOMER_ADDRESS_PURPOSES, w as baseUseMutation, A as baseUseQuery, a as canadianProvinces, X as clients, o as countriesAlpha2, s as countriesAlpha2Emojis, t as createApiQueryClient, F as createApiQueryPersister, R as ensureQueryData, L as extractValidationErrors, T as fetchQuery, g as getBillingAddress, _ as getShippingAddress, c as getStateOptions, z as isQuickBooksErrorResponse, l as isRegionState, B as isSequenceApiError, C as isSequenceApiErrorResponse, v as isShippingSameAsBilling, u as statesForCountry, d as statesWithNamesForCountry, y as toBillingOnlyAddresses, f as toCountryLabel, b as toCustomerAddresses, p as toStateLabel, m as usStates, E as useApiQueryClient, P as useComplexQuery, j as useInfiniteQuery, k as useLoadAllItems, M as useLoadAllItemsQuery, N as useMockMutation, I as useMockQuery, O as useMutation, D as useQuery, x as useRunInvalidationForMutation, S as useSequenceInfiniteQuery };

//# sourceMappingURL=index.js.map